import { Language } from '@/types';
import { useCurrentLanguage } from '@/utils/i18n.utils';

import { useLocations } from '../api/get-locations';
import { Location } from '../types';

const buildLocationEntries = (
  location: Location,
  currentLanguage: Language
): [string, string][] => {
  const entries: [string, string][] = [[location.value, location.labels[currentLanguage]]];

  for (const subLocation of location.options ?? []) {
    entries.push(...buildLocationEntries(subLocation, currentLanguage)); // Recursively process sublocations
  }

  return entries;
};

export function useLocationCodeToLabel() {
  const { data: locations = [] } = useLocations();
  const currentLanguage = useCurrentLanguage();

  const locationCodeToLabel: Record<string, string> = Object.fromEntries(
    locations.flatMap(location => buildLocationEntries(location, currentLanguage))
  );

  return locationCodeToLabel;
}
